import strings from '../../Localization/Localization';

import { fetchActiveAppointmentActions } from '../../API/AppointmentActions';

let appointmentAction = {
  fieldKey: "appointment_action",
  label: strings.form.usedAppointmentAction.appointmentAction.label,
  type: "dropdownEntity",

  validators: [
    {
      id: 'assertEmpty',
      type: 'notEmptyOrNull',
      invalidFeedback: strings.form.usedAppointmentAction.appointmentAction.invalid.assertEmpty,
      defaultValue: false
    },
  ],

  showEmpty: true,
  filterOptions: (item, getValues, getExtraValues) => {
    let ticket = getExtraValues().ticket;
    let valid = true;

    if(!ticket) {
      return false;
    }

    if(item["all_ticket_group"] !== true) {
      valid &= item["ticket_groups"].some(ticketGroup => ticketGroup.id === ticket["request_type"]["group"].id);
    }

    if(item["all_product_family"] !== true && !ticket["ticket_origin"]) {
      let productFamilies = [];
      switch (ticket["ticket_origin"]["origin_type"]) {
        case "product_sub_family":
          productFamilies.push(ticket["ticket_origin"]["product_sub_family"]["product_family"]);
          break;
        case "service":
          productFamilies.push(ticket["ticket_origin"]["service"]["cart_item"]["product"]["product_sub_family"]["product_family"]);
          break;
        case "order":
          ticket["ticket_origin"]["order"]["sub_families"].forEach((subFamily) => {
            if(!productFamilies.some(tempFamily => tempFamily["id"] === subFamily["product_family"]["id"])) {
              productFamilies.push(subFamily["product_family"]);
            }
          });
          break;
        case "none":
        default:
      }
      valid &= item["product_families"].some(itemProductFamily => productFamilies.some(productFamily => itemProductFamily.id === productFamily.id));
    }

    if(item["all_product_sub_family"] !== true && !ticket["ticket_origin"]) {
      let productSubFamilies = [];
      switch (ticket["ticket_origin"]["origin_type"]) {
        case "product_sub_family":
          productSubFamilies.push(ticket["ticket_origin"]["product_sub_family"]);
          break;
        case "service":
          productSubFamilies.push(ticket["ticket_origin"]["service"]["cart_item"]["product"]["product_sub_family"]);
          break;
        case "order":
          productSubFamilies = ticket["ticket_origin"]["order"]["sub_families"];
          break;
        case "none":
        default:
      }
      valid &= item["product_sub_families"].some(itemProductSubFamily => productSubFamilies.some(productSubFamily => itemProductSubFamily.id === productSubFamily.id));
    }

    return valid;
  },
  loader: {
    id: "appointmentActions",
    loader: fetchActiveAppointmentActions,
    loaderRequire: () => true,
    loaderArguments: () => [],
  },

  adapter: {
    requirement: (data) => data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

let quantity = {
  fieldKey: "quantity",
  type: "text",
  label: strings.form.usedAppointmentAction.quantity.label,
  validators: [
    {
      id: 'assertEmpty',
      type: 'regex',
      conf: {
        regex: /\d+/
      },
      invalidFeedback: strings.form.usedAppointmentAction.quantity.invalid.assertEmpty,
      defaultValue: false
    },
  ]
}

export const form = {
  formKey: "usedAppointmentActions",
  fields: [
    appointmentAction,
    quantity
  ]
}
